import React, { memo } from 'react';
import HBAddressPostalField from './HBAddressPostalField';
import useFormFieldProps, {
    FormFieldProps,
    TFormInputValidationProps,
    useFormInputValidationProps
} from '../HBFormFields/useFormFieldProps';
import type { HBInputFieldProps } from '../HBInputField/HBInputField';

export type HBFormAddressPostalFieldProps = Omit<
    FormFieldProps<HBInputFieldProps>,
    TFormInputValidationProps | 'label' | 'ref'
> & {
    /** The currently selected country code. Determines label and HTML5 pattern validation. */
    country: string;
    /** Override the auto-derived label (e.g. ZIP Code, Postal Code, Postcode). */
    label?: string;
};

const HBFormAddressPostalField = ({
    country,
    label,
    ...props
}: HBFormAddressPostalFieldProps) => {
    const fieldProps = useFormFieldProps(props, true);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBAddressPostalField
            {...fieldProps}
            {...validationProps}
            country={country}
            label={label}
        />
    );
};

export default memo(HBFormAddressPostalField);
